// extracted by css-extract-rspack-plugin
export default {"cls1":"Unibrow-cls1_pAZ","cls2":"Unibrow-cls2_Eep Unibrow-cls1_pAZ"};